import { Subject } from 'rxjs';

import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

import { ISnAuthConfig } from '@lib/auth';
import { snFadeInDown } from '@lib/common/animations';

import { SN_AUTH_CONFIG } from '../../providers';
import { SnSessionService } from '../../services';

@Component({
  selector: 'sn-axon-disclaimer',
  templateUrl: './axon-disclaimer.component.html',
  styleUrls: ['./axon-disclaimer.component.scss'],
  animations: [snFadeInDown],
})
export class AxonDisclaimerComponent implements OnDestroy, OnInit {
  public _redirectUrl: string;
  public complianceMessage: string;
  public complianceTitle: string;
  public isLoading = false;
  private readonly _destroy$ = new Subject<void>();

  constructor(
    activatedRoute: ActivatedRoute,
    private readonly _dialogRef: MatDialogRef<AxonDisclaimerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string; title: string },
    private readonly _sessionService: SnSessionService,
    @Inject(SN_AUTH_CONFIG) authConfig: ISnAuthConfig,
  ) {
    const queryParams = activatedRoute.snapshot.queryParams;
    this._redirectUrl = queryParams.redirectUrl || authConfig.redirectAuthorizedTo;
    this.complianceMessage = data.message;
    this.complianceTitle = data.title;
  }

  public ngOnInit(): void {}

  public acceptedDisclaimer(): void {
    this._dialogRef.close(true);
  }

  public logOut(): void {
    this._dialogRef.close();
    this._sessionService.logout({
      reason: 'axonDisclaimer:closed',
    });
  }

  public close(): void {
    this._dialogRef.close(false);
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
